import { api, URLs } from '@/libs/api'
import type { ApiResponse } from '@/libs/interfaces'
import type { EmployeeCheckinData } from '@/libs/interfaces/checkIn'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { checkInApiMock } from '@/libs/mocks/handlers/checkIn'

export interface PunchPayload {
  employeeCheckedOut: 'CheckedIn' | 'CheckedOut'
  employeePin: string
  signature: string
}

const checkInApiReal = {
  getcheckInStatus: async (storeID: string): Promise<EmployeeCheckinData> =>
    await api
      .get<ApiResponse<EmployeeCheckinData>>(URLs.CHECKIN_STATUS(storeID))
      .then((response) => response.data?.data),

  checkIn: async (storeID: string, employeeID: string, payload: PunchPayload): Promise<void> => {
    await api.post(URLs.checkIn.create(storeID, employeeID), payload)
  },

  // checkOut: async (storeID: string, employeeID: string, payload: PunchPayload): Promise<void> => {
  //   await api.post(URLs.CHECKOUT(storeID, employeeID), payload)
  // },
}

export const checkInApi: typeof checkInApiReal = IS_MOCK_MODE ? checkInApiMock : checkInApiReal
